module.exports = __webpack_public_path__ + "img/dashboard_active.747a12a7.svg";